import { UploadFileModalComponent } from '@1bill-app/components/modals/upload-file-modal/upload-file-modal.component';
import { ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { blobToFile, fileToArrayBuffer } from '@1bill-app/helpers/file.helper';
// import { v1 as uuid } from 'uuid';
import { ImagePdfService } from '@1bill-app/services/image-pdf/image-pdf.service';
import { StatusService } from '@1bill-app/services/status/status.service';
// import { faFileUpload } from '@fortawesome/pro-light-svg-icons';
import { UploadService } from '@1bill-app/services/upload/upload.service';
// import { UploadQuery } from '@1bill-app/services/upload/upload.query';
import { UploadStore } from '@1bill-app/services/upload/upload.store';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ModalController, NavController, Platform, PopoverController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { PopoverInfoIconComponent } from '@1bill-app/components/popover/popover-info-icon/popover-info-icon.component';
import { EXPLANATION_NOTES_SIMPLE } from '@1bill-app/constants';

@Component({
  selector: 'app-upload-pdf-bill',
  templateUrl: './upload-pdf-bill.component.html',
  styleUrls: ['./upload-pdf-bill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadPdfBillComponent implements OnInit {
  @ViewChild('fileInputPdf', { static: false }) fileInputPdf: ElementRef;
  @ViewChild('uploadFormPdf', { static: false }) uploadFormPdf: any;
  // @Input() event: {
  //   uploadProgress: number;
  //   isUploading: boolean;
  //   error: string;
  //   errorCode: string;
  // };
  // @Input() firstBill = false;
  @Output() upload: EventEmitter<any> = new EventEmitter();
  dropzoneActive: boolean;
  // loading: boolean;
  isConvertingPdf: boolean;
  isUploadingImgs: boolean;
  dragDropError: string;
  public files: File[];

  constructor(
    private uploadService: UploadService,
    private _cd: ChangeDetectorRef,
    private _imagePdf: ImagePdfService,
    public platform: Platform,
    private uploadStore: UploadStore,
    private modalCtrl: ModalController,
    private statusService: StatusService,
    private navCtrl: NavController,
    private logger: NGXLogger,
    private popoverController: PopoverController,
  ) {
    // library.addIcons(faFileUpload);
  }

  ngOnInit() {}

  async selectPdf(event, dragAndDrop: boolean = false) {
    // Initialize with default values every time
    this.uploadStore.update({ isUploading: false, hasUploadErr: false, hasUploaded: false });

    // this.loading = true;
    const methodName = 'selectPdf';
    this._cd.detectChanges();
    try {
      this.uploadStore.update({ isUploading: true });
      // this.showFileUploading();
      // await this._uploadCommon.fileIsUploading('PDF');
      const modal = await this.modalCtrl.create({
        component: UploadFileModalComponent,
        cssClass: 'my-custom-class',
        backdropDismiss: false,
        id: 'file-uploading-modal',
        componentProps: {
          source: 'PDF',
        },
      });
      await modal.present();

      let files: any[];

      if (dragAndDrop) {
        files = event;
      } else {
        files = event.target.files as any[];
      }
      const pdfFile: File = [...files]
        .filter((file: File) => file.type.includes('pdf'))
        .find((e) => !!e);
      if (!pdfFile) {
        this.uploadStore.update({ isUploading: false });
        modal.dismiss();
        return;
      }

      this.isConvertingPdf = true;
      this._cd.detectChanges();
      // convert file to buffer
      const buffer = await fileToArrayBuffer(pdfFile);
      // convert pdf to image blobs
      const blobs = await this._imagePdf.convertPdfToBlob(buffer);
      this.logger.info(methodName, 'converted pdf to blob');

      this.isConvertingPdf = false;
      this._cd.detectChanges();
      this.isUploadingImgs = true;
      this._cd.detectChanges();
      // upload image blobs
      const imgs = (
        await Promise.all(
          [...blobs].map((blob, i) => {
            const filename = pdfFile.name + '-' + i + '.png';
            const file = blobToFile(blob, filename);
            return this.uploadService.uploadPhotoBill(file, false).toPromise();
          }),
        )
      ).map((data) => data.s3Key); // s3-url-to-key
      this.isUploadingImgs = false;
      this._cd.detectChanges();
      this.logger.info(methodName, 'uploaded blob image to server');

      // this.loading = false;
      this.uploadStore.update({ isUploading: false, hasUploaded: true });
      this._cd.detectChanges();

      const dismiss = await modal.onWillDismiss();
      this.logger.log('Dismiss data:', dismiss.data);
      if (dismiss.data.cusSelected) {
        this.statusService.updateJobMeta(dismiss.data);
      }

      // emit value to parent component
      // ! here
      const value = { target: { files: [pdfFile], imgs } };
      this.logger.info(methodName, 'component emit value', value);

      this.upload.emit(value);
      if (dismiss.role === 'go-home') {
        this.navCtrl.navigateRoot([ROUTE_HOMEPAGE], { queryParams: { job: true } });
      }

      this.presentuploadSuccess();
    } catch (err) {
      this.uploadStore.update({ isUploading: false, hasUploaded: false, hasUploadErr: true });
      this.logger.error(methodName, err);
    }
    this._cd.detectChanges();
    // this.loading = false;
    this.uploadFormPdf.nativeElement.reset();
    this.uploadService.clearPhotoBillsUpload(); // clears photos created by pdf bills
  }

  async presentuploadSuccess() {
    const popover = await this.popoverController.create({
      component: PopoverInfoIconComponent,
      cssClass: 'popover-info-icon-modal',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        iconSource: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_ICON,
        popoverTitle: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_TITLE,
        description: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_DESC,
        descriptionTwo: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_DESC_TWO,
      },
    });
    return await popover.present();
  }

  onPdfSelectClick() {
    return this.fileInputPdf.nativeElement.click();
  }
  handlePdfDrop(fileList: FileList) {
    if (fileList.length > 1) {
      this.dragDropError = 'Please upload only one pdf bill.';
      return;
    }

    if (fileList[0].type !== 'application/pdf') {
      this.dragDropError = 'Please upload pdf bill only.';
      return;
    }
    this.dragDropError = null;
    this.selectPdf(fileList, true);

    // this.upload(Array.from(fileList), 'PDF', true);
  }
  dropzoneState($event: boolean) {
    this.dropzoneActive = $event;
  }
  isNaN(number: any) {
    return isNaN(number);
  }
}
